export enum AuthGuardEnum {
    ADMIN = 'admin',
    TEACHER = 'teacher',
    STUDENT = 'student',
}

export const authGuardText = {
    [AuthGuardEnum.ADMIN]: '관리자',
    [AuthGuardEnum.TEACHER]: '선생님',
    [AuthGuardEnum.STUDENT]: '학생',
};
